import ScrollReveal from 'scrollreveal';
export default ScrollReveal();